import { useEffect, useState, type ReactNode } from 'react';
import { fetchAndApplyOverrides } from '../data/refreshOverrides';

/**
 * OverridesGate — espera a que lleguen los overrides de Modo Edición
 * (posición, cableado, altas/bajas — guardado directo, ver
 * overridesRuntime.ts) antes de montar el mapa. Evita el flash de "posición
 * vieja" que se vería si el mapa se montara con los arrays todavía vacíos y
 * los overrides llegaran un instante después.
 *
 * Si el fetch falla, deja pasar igual (arrays vacíos, dashboard operativo
 * sin las correcciones de campo) — un operador normal no debe quedarse sin
 * dashboard por un problema en este endpoint, que es una mejora, no un
 * requisito para operar.
 */
export function OverridesGate({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    fetchAndApplyOverrides()
      .catch(e => console.warn('No se pudieron cargar los overrides de Modo Edición:', e))
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div className="h-screen bg-gray-950 flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-gray-400 font-mono">Cargando…</span>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
